export const VARIANT = `fragment Variant on ProductVariant {
  id
  sku
  image {
    altText
    url(transform: { maxWidth: 800 })
  }
  compareAtPrice { amount }
  price { amount }
  selectedOptions { value, name }
  color_group: metafield(key: "color_group", namespace: "filter") { value }
  color_pattern: metafield(key: "color_pattern", namespace: "filter") { value }
  size_grouping: metafield(key: "size_grouping", namespace: "filter") { value }
  pattern_group: metafield(key: "pattern_group", namespace: "filter") { value }
  hoverImage: metafield(key: "hover_lifestyle_image", namespace: "acf_pdp") {
    reference {
      ... on MediaImage {
        image {
          url(
            transform: { maxWidth: 800 }
          )
        }
      }
    }
  }
}`;

export const PRODUCT_CARD = `fragment ProductCard on Product {
  title
  id
  handle
  tags
  options { name, values }
  priceRange { minVariantPrice { amount } }
  shortDescription: metafield(namespace: "acf_pdp", key: "description_short") {
    value
  }
  fromPrice: metafield(namespace: "acf_pdp", key: "from_price") {
    value
  }
  textBadge: metafield(namespace: "acf_pdp", key: "badge_text_2") {
    value
  }
  imageBadge: metafield(namespace: "acf_pdp", key: "badge_asset") {
    value
  }
  variants (first: $variantsRetrieved) {
    nodes {
      ... Variant
    }
  }
  featuredSku: metafield(namespace: "acf_pdp", key: "featured_sku") {
    reference {
      ... Variant
    }
  }
}${VARIANT}`;

export const PRODUCTS_FROM_COLLECTION_QUERY = `
query ProductsFromCollection($handle: String!, $first: Int!, $after: String, $filters: [ProductFilter!], $sortKey: ProductCollectionSortKeys!, $variantsRetrieved: Int!) {
  collection(handle: $handle) {
    id
    title
    products(first: $first, after: $after, sortKey:$sortKey, filters: $filters) {
      pageInfo {
        hasNextPage
        endCursor
      }
      filters {
        label
        id
        values {
          label
          id
          input
          swatch { 
            color
            image {
              data: image {
                  url
              }
            }
          }
        }
      }
      edges {
        cursor
        node {
          ... ProductCard
        }
      }
    }
  }
}${PRODUCT_CARD}`;

export const VARIANT_FROM_SELECTIONS = `query ProductCard($handle: String!, $options: [SelectedOptionInput!]!) {
  product(handle: $handle) {
    variantBySelectedOptions(selectedOptions: $options) {
      ... Variant
    }
  }
}${VARIANT}`;

export const FACET_DETAILS_QUERY = `query FacetDetails($handle: String!, $type: String!) {
  metaobject(handle: { handle: $handle, type: $type }) {
    fields {
      key
      value
    }
  }
}`;
